import { BaseModel } from "../BaseModel";

export class GlobalSettings extends BaseModel
{
    
    EnableState:boolean;
    StateId:number;
    EnableEmpId:boolean;
    LocalIdInd:string;  
    LocalIdIndDigit:number;  
    LocalIdIndRequired:boolean;    
    LocalIdIndConfig:string;
    LocalIdIndConfig1:number;
    LocalIdIndConfig2:number;
    LocalIdIndConfig3:number;
    LocalIdIndConfig4:number;
    LocalIdIndConfig5:number;
    LocalIdIndConfig6:number;
    IndDrop1:string;
    IndDrop2:string;
    IndDrop3:string;
    IndDrop4:string;
    IndDrop5:string;
    IndDrop6:string;
    LocalIdCorp:string;
    LocalIdCorpDigit:number;
    LocalIdCorpRequired:boolean;
    LocalIdCorpConfig:string;
    LocalIdCorpConfig1:number;
    LocalIdCorpConfig2:number;
    LocalIdCorpConfig3:number;
    LocalIdCorpConfig4:number;
    LocalIdCorpConfig5:number;
    LocalIdCorpConfig6:number;
    CorpDrop1:string;
    CorpDrop2:string;
    CorpDrop3:string;
    CorpDrop4:string;
    CorpDrop5:string;
    CorpDrop6:string;
    IncomeTaxId:string;
    IncomeTaxDigit:number;
    IncomeTaxRequired:boolean;
    IncomeTaxConfig:string;
    IncomeTaxConfig1:number;
    IncomeTaxConfig2:number;
    IncomeTaxConfig3:number;
    IncomeTaxConfig4:number;
    IncomeTaxConfig5:number;
    IncomeTaxConfig6:number;
    IncomeDrop1:string;
    IncomeDrop2:string;
    IncomeDrop3:string;
    IncomeDrop4:string;
    IncomeDrop5:string;
    IncomeDrop6:string;
    IndirectTaxId:string;
    IndirectTaxDigit:number;
    IndirectTaxRequired:boolean;
    IndirectTaxConfig:string;
    IndirectTaxConfig1:number;
    IndirectTaxConfig2:number;
    IndirectTaxConfig3:number;
    IndirectTaxConfig4:number;
    IndirectTaxConfig5:number;
    IndirectTaxConfig6:number;
    IndirectDrop1:string;
    IndirectDrop2:string;
    IndirectDrop3:string;
    IndirectDrop4:string;
    IndirectDrop5:string;
    IndirectDrop6:string;

     
}
